export enum localStorageConstants {
    // Common
    USER_TYPE = 'user-type',
    LANGUAGE = 'language',
    THEME_TYPE = 'theme-type',

    // Portal
    PORTAL_TOKEN = 'portal-token',

    // Super Admin
    SUPER_ADMIN_TOKEN = 'super-admin-token',
    SUPER_ADMIN_DATA = 'super-admin-data',

    // User/Company Portal
    USER_DATA = 'user-data',

    SUPER_ADMIN_LOGGED_IN  = 'super-admin-login',

    PORTAL_LOGGED_IN = 'portal-login',
}